import { render, staticRenderFns } from "./rightBar.vue?vue&type=template&id=b110d23c&scoped=true&"
import script from "./rightBar.vue?vue&type=script&lang=js&"
export * from "./rightBar.vue?vue&type=script&lang=js&"
import style0 from "./rightBar.vue?vue&type=style&index=0&id=b110d23c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b110d23c",
  null
  
)

export default component.exports